import * as React from "react"
import ReportLoadingMessage from "../ReportLoadingMessage"
import SummaryFilters from "../SummaryFilters"
import { TeacherStore, ITeacherStoreData, NotificationType } from "../../../stores/teacher.store"
import { StudentData } from "../types"
import { NOT_SPECIFIED } from "../../../constants"
import { SprintsRest } from "../../../services/sprints/sprints-rest-interface"
import { TeacherSprintStats } from "../../../services/sprints/teacher-stats"
import TimedSprintsSections from "./TimedSprintsSections"
import "./index.css"

export interface Props {}
interface State {
    selectedSchoolName?: string
    selectedGraduationYear?: string
    selectedPeriod?: string
    selectedSubject: string
    data: StudentData[]
    selectedData: StudentData[]
    stats?: TeacherSprintStats
    loaded: boolean
    error: boolean
}

export default class TimedSprintsOverview extends React.Component<Props, State> {
    unsubscribe?: () => void
    private mounted = false
    state: State = { selectedSubject: "english", data: [], selectedData: [], loaded: false, error: false }

    componentDidMount() {
        this.mounted = true
        this.unsubscribe = TeacherStore.subscribe((data, type) => this.setMainData(data, type))
        this.setMainData(TeacherStore.data, NotificationType.GENERIC)
        TeacherStore.loadStudents()
        this.loadStats()
    }

    componentWillUnmount() {
        this.mounted = false
        if (this.unsubscribe) this.unsubscribe()
    }

    loadStats = async () => {
        this.setState({ loaded: false, error: false })
        try {
            let stats = await SprintsRest.getTeacherStudentsStats()
            if (!stats || !Array.isArray(stats.questions)) throw new Error("Invalid sprint statistics")
            if (this.mounted) this.setState({ stats, loaded: true })
        } catch (error) {
            if (this.mounted) this.setState({ loaded: true, error: true })
        }
    }

    setMainData(data: ITeacherStoreData, type?: NotificationType) {
        if (type !== NotificationType.STUDENTS && type !== NotificationType.GENERIC) return
        this.setState({ data: data.students }, this.applyFilter)
    }

    onGraduationYearSelected(selectedYear: string) {
        this.setState({ selectedGraduationYear: selectedYear === "All" ? undefined : selectedYear }, () => this.applyFilter())
    }

    onNewSchoolSelected(selectedSchool: string) {
        this.setState(
            {
                selectedSchoolName: selectedSchool === "All" ? undefined : selectedSchool,
            },
            () => this.applyFilter(),
        )
    }

    onNewPeriodSelected(selectedPeriod: string) {
        this.setState(
            {
                selectedPeriod: selectedPeriod === "All" ? undefined : selectedPeriod,
            },
            () => this.applyFilter(),
        )
    }

    onTimeRangeSelected(selected: string) {}

    onSubjectSelected(selected: string) {
        this.setState(
            {
                selectedSubject: selected,
            },
            () => this.applyFilter(),
        )
    }

    private applyFilter = () => {
        let { data, selectedGraduationYear, selectedSchoolName, selectedPeriod } = this.state
        let selectedData = data.filter((d) => {
            let selectStudent = true
            let period = d.period || NOT_SPECIFIED
            if (
                (selectedGraduationYear && selectedGraduationYear !== d.graduationYear) ||
                (selectedSchoolName && selectedSchoolName !== d.schoolName) ||
                (selectedPeriod && selectedPeriod !== period)
            ) {
                selectStudent = false
            }
            return selectStudent
        })

        this.setState({ selectedData })
    }

    render() {
        let { selectedSubject, selectedData, stats, loaded, error } = this.state
        let allowedSubjects = ["english", "math", "reading"]
        return (
            <div className="lesson-overview timed-sprints-overview">
                <SummaryFilters
                    enableTimeRangeSelection={false}
                    enablePeriodSelection={true}
                    enableSubjectSelection={true}
                    allowedSubjects={allowedSubjects}
                    onNewGraduationYearSelected={(gradYear) => this.onGraduationYearSelected(gradYear)}
                    onNewSchoolSelected={(schoolSel) => this.onNewSchoolSelected(schoolSel)}
                    onNewPeriodSelected={(period) => this.onNewPeriodSelected(period)}
                    onNewTimeRangeSelected={(timeRange) => this.onTimeRangeSelected(timeRange)}
                    onNewSubjectSelected={(subject) => this.onSubjectSelected(subject)}
                />

                {!loaded && <ReportLoadingMessage />}
                <hr />
                {error && <div role="alert">Unable to load Timed Sprints results. <button onClick={this.loadStats}>Retry</button></div>}
                {loaded && !error && stats && <TimedSprintsSections subject={selectedSubject} students={selectedData} stats={stats} />}
            </div>
        )
    }
}
